import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import Label from "../Label";
import css from './StopMarker.module.css';
import markerCss from '../Marker.module.css';
import {getTs, gruntBossName} from "../../../utils";
import {StopOverlayTypes} from "../../../store/filterSlice";
import {connect} from "react-redux";
import pokedex from "../../../utils/pokedex";

const stopSecsLeft = (stop, stopOverlay) => {
	const ts = getTs();
	if( stopOverlay === StopOverlayTypes.GRUNT && stop.incident_expiration )
		return stop.incident_expiration - ts;
	else if( stopOverlay === StopOverlayTypes.LURE && stop.expiration )
		return stop.expiration - ts;

	return null;
};

const StopMarker = (props) => {
	const [secsLeft, setSecsLeft] = useState(stopSecsLeft(props.stop, props.stopOverlay));
	const timer = useRef(false);

	useEffect(() => {
		const secsUntilRefresh = secsLeft % 60 + 1;
		if( secsLeft > 0 )
			timer.current = setTimeout(() => {setSecsLeft(stopSecsLeft(props.stop, props.stopOverlay))}, secsUntilRefresh*1000);
		// console.log("Timer for " + props.stop.name, timer.current);
		// eslint-disable-next-line
	}, [secsLeft]);

	useEffect(() => {
		return () => {
			// console.log("Unmounting " + props.stop.name, timer.current);
			if( timer.current )
				clearTimeout(timer.current);
		} // eslint-disable-next-line
	}, []);

	if( secsLeft < 0 && !props.stopShowAll )
		return null;

	// Done with timer stuff

	const ts = getTs();

	const getIconAndLabel = () => {
		let icon = '/images/pokemon/pokestop.png';
		let label = null;
		if( props.stopOverlay === StopOverlayTypes.GRUNT && props.stop.incident_expiration > ts ) {
			const boss = gruntBossName(props.stop.incident_grunt_type, props.giovanni[props.stop.pokestop_id]);
			if (boss) {
				icon = '/images/pokemon/rocket/Gold.png';
				if( boss === 'Decoy' )
					icon = '/map/img/Giovanni-No.png';
				else if( boss === 'Giovanni?' )
					icon = '/map/img/Giovanni-Maybe.png';

				if( ['Arlo','Sierra','Cliff','Giovanni'].includes(boss) )
					icon = '/images/pokemon/rocket/' + boss + '.png';
				label = boss;
			} else {
				const typeId = props.stop.incident_grunt_type % 2 === 0 ? props.stop.incident_grunt_type : props.stop.incident_grunt_type - 1;
				icon = '/common/images/pokemon/osm-rm/pokestop/stop_i_' + typeId + '.png';
			}
		} else if( props.stopOverlay === StopOverlayTypes.LURE && props.stop.expiration > ts ) {
			icon = '/common/images/pokemon/osm-rm/pokestop/stop_l_' + props.stop.active_fort_modifier + '.png';
			const minsLeft = Math.floor((props.stop.expiration - ts)/60);
			label = minsLeft + 'm left';
		} else if( props.stopOverlay === StopOverlayTypes.QUEST ) {
			if( props.stop.quest && props.stop.reward_encounter ) { // OLD STYLE from MAD: TODO: Remove
				if( !pokedex[props.stop['reward_encounter']] ) {
					console.log("Unknown pokemon id: ", props.stop.reward_encounter);
					return;
				}
				const name = pokedex[props.stop['reward_encounter']] ? pokedex[props.stop['reward_encounter']]['name'] : "Unknown Pokemon #" + props.stop['reward_encounter'];
				label = <div className={css.RewardEncounter}><img alt='Quest' src={'https://www.a2pogo.com/images/pokemon/icons-4/' + props.stop['reward_encounter'] + '.png'} />
					{name}
					{props.stop['reward_encounter_state'] ? ' (' + props.stop['reward_encounter_state'] + ')' : ''}
				</div>;
			} else if( props.stop.quest && props.stop['reward_item_descr'] ) {
				label = props.stop['reward_item_descr'].replace(/\s+Bery/, '');
			} else if( props.stop.quest_title ) {
				// NEW STYLE, from RDM
				const rewards = JSON.parse(props.stop.quest_rewards);
				if( rewards ) {
					const reward = rewards[0];
					if( reward.type === 2 ) {
						icon = '/images/pokemon/icons/PogoAssets/uicons/reward/item/' + reward.info.item_id + '_a' + reward.info.amount + '.png';
					} else if( reward.type === 3 ) {
						icon = '/images/pokemon/icons/PogoAssets/uicons/reward/stardust/' + reward.info.amount + '.png';
					} else if( reward.type === 7 ) {
						icon = '/images/pokemon/icons/PogoAssets/uicons/pokemon/' + reward.info.pokemon_id + (reward.info.form ? '_f' + reward.info.form : '') + '.png';
					} else if( reward.type === 12 ) {
						icon = '/images/pokemon/icons/PogoAssets/uicons/reward/mega_resource/' + reward.info.pokemon_id + '_a' + reward.info.amount + '.png';
					} else {
						console.log("Unknown reward type:", reward.type);
					}
				}
			}
		}

		return {icon: 'https://www.a2pogo.com' + icon, label: label};
	};

	const {icon, label} = getIconAndLabel();

	return (<>
		{props.infoWindow}
		<div className={markerCss.Marker} >
			<div onClick={() => props.onClick(props.raid)}>
				<img className={css.Icon} src={icon} alt='Stop' />
			</div>

			{label && <Label text={label}/>}
		</div></>);

	/*
	const [secsLeft, setSecsLeft] = useState(getSecsLeft(props.raid.end));
	const timer = useRef(false);

	useEffect(() => {
		const secsUntilRefresh = secsLeft % 60 + 1;
		if( secsLeft > 0 )
			timer.current = setTimeout(() => {setSecsLeft(getSecsLeft(props.raid.end))}, secsUntilRefresh*1000);
		// console.log("Timer for " + props.raid.gym_name, timer.current);
		// eslint-disable-next-line
	}, [secsLeft]);

	useEffect(() => {
		return () => {
			// console.log("Unmounting " + props.raid.gym_name, timer.current);
			if( timer.current )
				clearTimeout(timer.current);
		}
		// eslint-disable-next-line
	}, []);

	if( secsLeft <= 0 )
		return null;

	const secsToStart = getSecsLeft(props.raid.start);

	const getIcon = () => {
		let icon = 'https://www.a2pogo.com/images/pokemon/raid-egg-48-' + props.raid.level + '.png';

		if( props.raid.pokemon_id )
			icon = 'https://www.a2pogo.com/images/pokemon/icons-4/' + props.raid.pokemon_id + '.png';

		return <img alt={'Raid at ' + props.raid.gym_name} src={icon} />;
	};

	const icon = getIcon();
	const label = secsToStart < 0 ? Math.floor(secsLeft/60) + "m left" : 'In ' + Math.floor(secsToStart/60) + "m";

	return (<>
	{props.infoWindow}
	<div className={markerCss.Marker} >

		<div onClick={() => props.onClick(props.raid)}>
			{icon}
		</div>

		<Label classes={[secsToStart < 0 ? labelCss.LabelRaidActive : labelCss.LabelRaidWaiting]} text={label}/>
	</div></>);
	*/
};



StopMarker.propTypes = {
	stop: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
	return {
		stopOverlay: state.filter.stopOverlay,
		stopShowAll: state.filter.stopShowAll,
		giovanni: state.marker.giovanni
	};
};

export default connect(mapStateToProps)(StopMarker);